import { Card, CardContent, CardHeader } from '@mui/material'
import React from 'react'
import { CustomCardProps } from './CustomCard.types';

const CustomCard = ({ title, subheader, icon, action, children, sx }: CustomCardProps) => {
    return (
        <Card sx={{ ...sx }} >
            {title && <CardHeader
                avatar={icon ? <>{icon}</> : undefined}
                title={title}
                subheader={subheader}
                action={action}
            />}
            <CardContent>
                {children}
            </CardContent>
        </Card>
    )
}

export default CustomCard